const containers = [
  ...document.querySelectorAll(".reveal"),
  ...document.querySelectorAll(".reveal-left"),
  ...document.querySelectorAll(".reveal-300"),
  ...document.querySelectorAll(".reveal-600"),
  ...document.querySelectorAll(".reveal-right"),
];
const windowHeight = window.innerHeight;
if (containers.length > 0) {
  function reveal() {
    containers.forEach((container) => {
      const containerTop = container.getBoundingClientRect().top;
      if (containerTop < windowHeight) {
        container.classList.add("reveal-show");
      }
    });
  }

  window.addEventListener("scroll", reveal);
  document.addEventListener("DOMContentLoaded", reveal);
}

const navbar = document.getElementById("navigation");

window.addEventListener("scroll", () => {
  if (window.location.pathname !== "/" && window.location.pathname !== "/en/") return;
  if (window.scrollY > 80) {
    navbar.classList.remove("nav--homepage");
    navbar.classList.add("bg-white");
    navbar.classList.add("text-black");
  } else {
    navbar.classList.remove("bg-white");
    navbar.classList.remove("text-black");
    navbar.classList.add("nav--homepage");
  }
});

const yearElement = document.getElementById("year");
const currentDate = new Date();
const currentYear = currentDate.getFullYear();

yearElement.innerText = currentYear.toString();

const counterSection = document.getElementById("counter-section");

if (counterSection) {
  function animateCountUpOnScroll(element, targetNumber, decimalPlaces = 0) {
    const duration = 2000;
    const startTimestamp = performance.now();
    const initialValue = parseFloat(element.innerText) || 0;

    function updateCounter(timestamp) {
      const elapsed = timestamp - startTimestamp;
      const progress = Math.min(elapsed / duration, 1);

      const currentValue =
        initialValue + (targetNumber - initialValue) * progress;
      element.innerText = currentValue.toFixed(decimalPlaces);

      if (progress < 1) {
        requestAnimationFrame(updateCounter);
      }
    }

    requestAnimationFrame(updateCounter);
  }

  function handleIntersection(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        [...entry.target.getElementsByTagName("strong")].forEach((element) => {
          const targetNumber = parseFloat(element.dataset.count) || 0;
          const decimalPlaces = parseInt(element.dataset.decimalPlaces) || 0;

          animateCountUpOnScroll(element, targetNumber, decimalPlaces);
        });

        observer.unobserve(entry.target);
      }
    });
  }

  const options = {
    threshold: 0.5, // Adjust as needed
  };

  const observer = new IntersectionObserver(handleIntersection, options);
  observer.observe(counterSection);
}

const container = document.getElementById("container");
const containerToRight = document.getElementById("containerToRight");
const backgroundToLeft = document.getElementById("background");
const backgroundToRight = document.getElementById("backgroundToRight");

const updateBackgroundPosition = (container, background) => {
  if (window.innerWidth >= 1024) {
    background.style.width =
      container.offsetLeft + container.offsetWidth / 2 + 15 + "px";
  } else {
    background.style.width = "100%";
  }
};

if (container) {
  window.addEventListener("resize", () =>
    updateBackgroundPosition(container, backgroundToLeft)
  );
  document.addEventListener("DOMContentLoaded", () =>
    updateBackgroundPosition(container, backgroundToLeft)
  );
}
if (backgroundToRight) {
  window.addEventListener("resize", () =>
    updateBackgroundPosition(containerToRight, backgroundToRight)
  );
  document.addEventListener("DOMContentLoaded", () =>
    updateBackgroundPosition(containerToRight, backgroundToRight)
  );
}

const hamburger = document.getElementById("hamburger");
const nav = document.getElementById("navigation");
// const mobileMenu = document.getElementById("mobileMenu");

hamburger.addEventListener("click", () => {
  nav.classList.toggle("active");
  // mobileMenu.classList.toggle("-right-full");
});

// mobileMenu.addEventListener("click", e => {
//   e.stopPropagation();
//   if (e.target.nodeName === "BUTTON") {
//     e.target.previousSibling.classList.toggle('active');
//   }
// })

const dropdowns = document.querySelectorAll(".dropdown");

dropdowns.forEach((dropdown) => {
  const parent = dropdown.parentElement;
  const parentMenuItem = [...parent.children].find(
    (element) => element.nodeName === "A"
  );
  const closeButton = [...dropdown.children].find(
    (element) => element.nodeName === "BUTTON"
  );

  parent.addEventListener("mouseenter", () => {
    dropdown.style.display = "flex";
    parent.classList.add("active");
  });
  parent.addEventListener("mouseleave", () => {
    dropdown.style.display = "none";
    parent.classList.remove("active");
  });

  if (window.innerWidth <= 1024) {
    parentMenuItem.addEventListener("click", (e) => {
      e.preventDefault();
      parent.classList.add("open");
    });

    closeButton &&
      closeButton.addEventListener("click", () => {
        parent.classList.remove("open");
      });
  }
});

const currentUrl = window.location.href;
const menuItems = document.querySelectorAll("#navList .menu-item");

const getPathWithoutEdgeSlashes = (urlPath) =>
  urlPath.slice(1, urlPath.length - 1);
const getPathElements = (urlPath) => urlPath.split("/");

const currentPathURL = new URL(currentUrl).pathname;
const currentPath = getPathWithoutEdgeSlashes(currentPathURL);
const currentPathElements = getPathElements(currentPath);

menuItems.forEach(function (menuItem) {
  const link = menuItem.querySelector("a");
  const href = link.getAttribute("href");

  if (currentUrl.includes(href)) {
    menuItem.classList.add("active");
    const subMenuLinks = menuItem.querySelectorAll(".sub-menu-item a");

    subMenuLinks.forEach((link) => {
      const itemUrl = new URL(link.getAttribute("href")).pathname;
      const menuItemsPath = getPathWithoutEdgeSlashes(itemUrl);
      const menuItemsPathElements = getPathElements(menuItemsPath);

      if (
        menuItemsPathElements[menuItemsPathElements.length - 1] ===
        currentPathElements[currentPathElements.length - 1]
      ) {
        link.parentElement.classList.add("active");
      }
    });
  }
});

const swiperPhotosSliders = document.querySelectorAll(".swiper-photos-slider");

swiperPhotosSliders.forEach((slider) => {
  new Swiper(slider, {
    slidesPerView: 1,
    spaceBetween: 32,
    loop: true,
    navigation: {
      nextEl: "#sliderPhotosNavigation .swiper-button-next",
      prevEl: "#sliderPhotosNavigation .swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
    },
    breakpoints: {
      1024: {
        slidesPerView: 2,
      },
      1536: {
        slidesPerView: 3,
      },
    },
  });
});

const initAccordion = (accordion) => {
  const accordionItems = accordion.querySelectorAll(".accordion-item");
  const toggledAccordion = document.getElementById("toggledAccordion");
  const hash = new URL(window.location).hash;

  if (toggledAccordion && hash) {
    const currentUrlSector = document.querySelector(hash);
    currentUrlSector.classList.add("active");
  }

  accordionItems.forEach((item) => {
    const header = item;
    const content = item.nextElementSibling;

    // Add click event listener to accordion header
    header.addEventListener("click", () => {
      // Toggle open accordion
      const accordionType = item.attributes["data-accordion"];
      if (accordionType && accordionType.value === "toggle-accordion") {
        const toggledItems = document.querySelectorAll(
          "[data-accordion='toggle-accordion']"
        );
        if (item.classList.contains("active"))
          return item.classList.remove("active");

        toggledItems.forEach((toggledItem) =>
          toggledItem.classList.remove("active")
        );
      }

      item.classList.toggle("active");
      content.classList.toggle("active");
      const buttonApply = document.querySelector(`[data-button="apply"]`);

      if (buttonApply) {
        buttonApply.addEventListener("click", (e) => e.stopPropagation());
      }

      if (content.parentElement.classList.contains("accordion--buttons")) {
        const button = document.querySelector(
          `[data-accordion='${item.attributes["data-button"].value}']`
        );
        if (item.classList.contains("active")) {
          button.innerText = "Zamknij";
        } else {
          button.innerText = "Szczegóły";
        }
      }

      // If there's a nested accordion, initialize it
      const nestedAccordion = content.querySelector(".accordion");
      if (nestedAccordion) {
        initAccordion(nestedAccordion);
      }
    });
  });
};

const accordions = document.querySelectorAll(".accordion");
accordions.forEach((accordion) => {
  initAccordion(accordion);
});

function scrollToActiveTab() {
  const activeTab = document.querySelector(".gallery__tab--active"); // Find the active tab
  const scrollContainer = document.querySelector(".tabs-scroll"); // Find the scroll container

  if (activeTab) {
    // Calculate the position to scroll to
    // This will be the active tab's offsetLeft + half its width - half the container's width
    const activeTabLeft = activeTab.offsetLeft;
    const activeTabWidth = activeTab.offsetWidth;
    const scrollContainerWidth = scrollContainer.offsetWidth;

    const scrollTo = activeTabLeft + activeTabWidth / 2 - scrollContainerWidth / 2;

    // Apply the scroll
    scrollContainer.scroll({
      left: scrollTo,
      behavior: 'smooth'
    });
  }
}

const gallery = document.getElementById("gallery");
const tabs = document.querySelectorAll(".gallery__tab");
const items = document.querySelectorAll(".gallery__item");
const loadMoreButton = document.getElementById("loadMore");

if (gallery) {
  const perPage = 6;
  let images = [];
  let totalCount = 0;
  let currentPage = 1;
  let offset = 0;

  const spinner = document.createElement("span");
  const getImagesByCategory = async (category) => {
    try {
      const res = await fetch(
        `${document.location.origin}/wp-json/gallery/v1/category/${category}`
      );
      const { gallery } = await res.json();
      const [{ images: data }] = gallery;
      const images = data;

      return images.map((img) => {
        return {
          id: img.id,
          alt: img.alt,
          title: img.title,
          urls: img.sizes
        };
      });
    } catch (e) {
      console.log(e);
    }
  };

  const render = () => {
    const offsetImages = images.slice(offset, perPage * currentPage);

    if (offsetImages.length > 0) {
      offsetImages.forEach((img) => {
        const galleryItem = document.createElement("a");
        galleryItem.classList.add("gallery__item");
        galleryItem.href = img.urls["2048x2048"];
        const galleryImg = document.createElement("img");
        galleryImg.src = img.urls.large;
        galleryImg.alt = img?.alt || img.title;
        galleryItem.append(galleryImg);
        gallery.append(galleryItem);
      });
    }
    spinner.remove();
  };

  loadMoreButton.addEventListener("click", () => {
    currentPage++;
    offset = offset + perPage;

    const limit = Math.ceil(totalCount / 6);
    if (limit > currentPage) {
      loadMoreButton.style.display = "block";
    }

    if (limit === currentPage) {
      loadMoreButton.style.display = "none";
    }
    render();
  });

  tabs.forEach((tab, index) => {
    tab.addEventListener("click", async () => {
      totalCount = 0;
      currentPage = 1;
      offset = 0;
      images = [];

      gallery.innerHTML = "";

      spinner.classList.add("spinner");
      gallery.append(spinner);

      tabs.forEach((tab) =>
        tab.classList.remove("gallery__tab--active")
      );

      tab.classList.add("gallery__tab--active");

      items.forEach((item) => (item.style.display = "none"));
      // Show items with matching data-tab attribute
      const selectedTab = tab.getAttribute("data-gallery");

      images = await getImagesByCategory(selectedTab);
      totalCount = images.length;

      const limit = Math.ceil(totalCount / 6);
      if (limit > currentPage) {
        loadMoreButton.style.display = "block";
      }

      render();
      scrollToActiveTab();
    });
  });

  tabs[0].click();
}

document.addEventListener("DOMContentLoaded", () => {
  scrollToActiveTab();
});

// Get all the menu items
const menuNavItems = document.querySelectorAll("ul.nav-links li");

// Loop through each menu item
menuNavItems.forEach(function (menuItem) {
  const link = menuItem.querySelector("a");
  const href = link.getAttribute("href");

  // Check if the current URL contains the menu item's href
  if (currentUrl.includes(href)) {
    menuItem.classList.add("active");
  }
});